import { PortfolioMilestone, PortfolioMilestonesResponse } from '@models';
import { CommonFunctionsService } from '@services';

export class PortfolioMilestoneMapper {
  constructor(private commonFunctionsService: CommonFunctionsService) {}

  mapFromJsonToModel(response: PortfolioMilestonesResponse): PortfolioMilestone[] {
    const allRows: PortfolioMilestone[] = [];

    Object.entries(response.data || {}).forEach(([clientName, studies]) => {
      Object.entries(studies).forEach(([studySk, studyData]) => {
        studyData.milestones?.forEach((ms) => {
          allRows.push({
            parentClientName: clientName,
            studySk: studySk,
            protocolNumber: studyData.protocolNumber || '',
            milestoneName: ms.name || '',
            status: ms.status || '',
            baselineDate: this.commonFunctionsService.formatDate(ms.values?.baseline || ''),
            plannedDate: this.commonFunctionsService.formatDate(ms.values?.planned || ''),
            actualDate: this.commonFunctionsService.formatDate(ms.values?.actual || ''),
            varianceFromBaselineDays: ms.baselineToActual ?? 0
          });
        });
      });
    });

    return allRows;
  }
}
